export default {
    kr: {
        LP: {
            nav: [{
                    name: "TOP",
                    id: "nav-top"
                },
                {
                    name: "메시지",
                    id: "nav-message"
                },
                {
                    name: "체험하다",
                    id: "nav-expenrise"
                },
                {
                    name: "아티스트",
                    id: "nav-artist"
                },
                {
                    name: "작품의 설치장소",
                    id: "nav-place"
                },
                {
                    name: "모두가 함께 만드는 DANDELION",
                    id: "nav-result"
                },
                // {
                //     name: "植樹支援のお願い",
                //     id: "nav-contribution"
                // },
                {
                    name: "서포터",
                    id: "nav-supporters"
                },
                {
                    name: "문의",
                    id: "nav-supporters"
                },
            ],
            top_desc_mb: "「DANDELION」은 세계와 연결되는 아트\n\n민들레에 숨을 불어 넣으면,\n날아오른 꽃씨가 네트워크를 통해 전세계에 흩날리고, \n각지에 설치된 「DANDELION」의 곁에서 꽃을 피웁니다.\n\n모여든 꽃들은 이윽고 아름다운 꽃밭으로 자랍니다.\n\n「세계에 평화가 찾아오기를」\n「더 나은 세상이  되기를」\n당신의 소원을 꽃씨에 실어, \n세상에 꽃을 피웁시다.",
            top_desc_pc: "「DANDELION」은 세계와 연결되는 아트\n\n민들레에 숨을 불어 넣으면,\n날아오른 꽃씨가 네트워크를 통해 전세계에 흩날리고, \n각지에 설치된 「DANDELION」의 곁에서 꽃을 피웁니다.\n\n모여든 꽃들은 이윽고 아름다운 꽃밭으로 자랍니다.\n\n「세계에 평화가 찾아오기를」\n「더 나은 세상이  되기를」\n당신의 소원을 꽃씨에 실어, \n세상에 꽃을 피웁시다.",
            msg: {
                msg_title: "메시지",
                msg_desc_mb: "2020년 이후, 모든 면에서 세계가 변화해 가는 가운데, 우리는 어떻게 세상과, 그리고 타인과 이어져 가는가.\n\n누구나 발신력을 가지고 누구와도 커뮤니케이션이 가능한 시대. \n말로 \"하나의 옳음\"에 대한 주의주장을 서로 호소한다면 끝이 없습니다만, 평화와 평온을 바라는 상냥한 마음을 통해, 사람들의 마음이 이어질 수도 있다고 믿고 싶습니다.\n\n「DANDELION」은 매우 간단한 행위로 전세계 사람들을 연결하는 작품입니다. 민들레에 소원을 담아 분다, 라는 누구나가 어렸을 때 놀았던 원체험적인 행위와, 세계 각지에서 순식간에 꽃이 피는 스케일이 합쳐진 이 작품을, 제 스스로도 매우 마음에 듭니다.\n\n꽃은 말을 필요로 하지 않으며, 어떤 일에 편을 가르지도 않습니다. 씨앗을 날려서 도착한 곳에서 다시 꽃을 피웁니다. 그런 식으로 국가나 인종, 사상에 관계없이 모두가 아트를 통해 이어져 전세계에 꽃을 피울 수 있기를 바랍니다.",

                msg_desc_pc: "2020년 이후, 모든 면에서 세계가 변화해 가는 가운데, 우리는 어떻게 세상과, 그리고 타인과 이어져 가는가.\n\n누구나 발신력을 가지고 누구와도 커뮤니케이션이 가능한 시대. \n말로 \"하나의 옳음\"에 대한 주의주장을 서로 호소한다면 끝이 없습니다만, 평화와 평온을 바라는 상냥한 마음을 통해, 사람들의 마음이 이어질 수도 있다고 믿고 싶습니다.\n\n「DANDELION」은 매우 간단한 행위로 전세계 사람들을 연결하는 작품입니다. \n민들레에 소원을 담아 분다, 라는 누구나가 어렸을 때 놀았던 원체험적인 행위와, 세계 각지에서 순식간에 꽃이 피는 스케일이 합쳐진 이 작품을, 제 스스로도 매우 마음에 듭니다.\n\n꽃은 말을 필요로 하지 않으며, 어떤 일에 편을 가르지도 않습니다. \n씨앗을 날려서 도착한 곳에서 다시 꽃을 피웁니다. \n그런 식으로 국가나 인종, 사상에 관계없이 모두가 아트를 통해 이어져 전세계에 꽃을 피울 수 있기를 바랍니다.",
                msg_foot: "무라마츠 료타로 / NAKED"
            },
            art: {
                title1: "아티스트",
                title2: "Ryotaro Muramatsu / NAKED",
                title3: "ARTIST",
                desc1: "아티스트. NAKED, INC. 대표. 1997년에 크리에이티브 컴퍼니 NAKED Inc.를 설립한 이래, 영화나 TV, MV, 광고, 공간 연출 등 장르를 뛰어 넘어 다양한 프로젝트를 이끌어 왔다.",
                desc2: "아티스트. NAKED, INC. 대표. 1997년에 크리에이티브 컴퍼니 NAKED Inc.를 설립한 이래, 영화나 TV, MV, 광고, 공간 연출 등 장르를 뛰어 넘어 다양한 프로젝트를 이끌어 왔다. 감독 작품은 장편/단편 합산 국제영화제 48개 부문 노미네이트&수상하였다. 최근에는 「FLOWERS BY NAKED」 「TOKYO ART CITY BY NAKED」등의 Immersive(몰입형) 이벤트나, 화도·다도·향도·가부키·노쿄겐 등 전통 문화와 예능과 진보적 표현을 합친 Installation Art(공간 예술)·공연을 연출하였다. 오사카 예술대학에서 객원 교수를 맡는 것 외에 브랜딩·디렉터를 맡고있는 나가노현·아치무라을 비롯해 오사카부·사카이시, 사가현 등 일본 각지에서의 지방 활설화 이벤트나 문화 프로젝트에 임함. 2018년에는 개인 아티스트로서 창작 활동을 하고 있으며, 국내외에서 작품을 발표해 왔다. 2019년 이탈리아 베니스에서 가루이자와 뉴 아트 뮤지엄이 주최한 「DIVERSITY FOR PEACE!」와 중국 소주에서 개최된 SUZHOU DESIGN WEEK에 참가하였으며, 홍콩에서는 HQUEENS의 화이트스톤 갤러리 홍콩에서 해외 최초의 개인전 「002」를 개최하는 것 외에 크리스티즈의 Christie's Autumn Auctions Hong Kong 2019에서 크리스티즈의 VIP 고객 초청 디너 파티를 연출했다. 2020년부터는 분단 시대에 평화를 위한 기도로 세계를 연결하는 네트워크형 아트 프로젝트 「DANDELION PROJECT」를 시작해 세계 각지에서의 작품 설치에 임하고 있다.",
            },
            experrience: {
                text_title1: '체험하다',
                text_title2_mb: "당신만의 꽃씨를 \n세상에 전합시다",
                text_title2_pc: "당신만의 꽃씨를 세상에 전합시다",
                text_btn: '「DANDELION」\n을 체험한다',
                text_link: '지원하다',
                text_desc: "이 프로젝트를 지원하여 \n「DANDELION」을 전 세계에 심으세요",
            },
            result: {
                text_title1_mb: "모두가 만드는 \nDANDELION",
                text_title1_pc: "모두가 만드는 DANDELION",
                text_title2: "FRIENDS OF\nDANDELION PROJECT",
                text_desc: "작품을 체험한 모두의 꽃씨는 여기에 모여 새로운 DANDELION을 만들어냅니다.",
                names: [{
                    firstName: "佐野光咲",
                    lastName: ""
                }, {
                    firstName: "佐野正騎",
                    lastName: ""
                }, {
                    firstName: "NOBU. MARUYAMA",
                    lastName: ""
                }, {
                    firstName: "JUN TERAYAMA",
                    lastName: ""
                }, {
                    firstName: "Ryuta Shimba",
                    lastName: ""
                }, {
                    firstName: "Shinsaku Nakagawa",
                    lastName: ""
                }, {
                    firstName: "Reiji Higashimaki",
                    lastName: ""
                }, {
                    firstName: "Erina",
                    lastName: ""
                }, {
                    firstName: "衞藤登喜子",
                    lastName: ""
                }, {
                    firstName: "深田しのぶ",
                    lastName: ""
                }, {
                    firstName: "小林優人",
                    lastName: ""
                }, {
                    firstName: "松田英樹",
                    lastName: ""
                }, {
                    firstName: "衞藤正和",
                    lastName: ""
                }, {
                    firstName: "衞藤弥保",
                    lastName: ""
                }]
            },
            placeText: {
                title: "작품의 설치장소",
                desc_mb: "“DANDELION” 작품은 전 세계에 전시하고 \n있습니다.",
                desc_pc: "“DANDELION” 작품은 전 세계에 전시하고 있습니다."
            },
            ctr: {
                title1: "서포트 방법",
                title2: "",
                desc1_mb: "『DANDELION PROJECT』는 세계 각지에 평화의 상징이 될 아트작품 「DANDELION」을 식수하기 위한 지원금을 모집하고 있습니다.전 세계에 꽃을 피우는 활동에 참여해 주십시오.",
                desc1_pc: "『DANDELION PROJECT』는 세계 각지에 평화의 상징이 될 아트작품 「DANDELION」을 식수하기 위한 지원금을 모집하고 있습니다.\n전 세계에 꽃을 피우는 활동에 참여해 주십시오.",
                desc2: "아래에서 지원 금액을 선택하신 후 \"지원하다\" 버튼을 누르십시오. ",
                btn1: "지원하다",
                btn2: "",
                input_tips: "금액을 자유롭게 입력하십시오.",
                price_type: "USD$",
                safari_tips1: "※Safari 사용하시는 분은",
                safari_tips2: "이쪽의 주의사항",
                safari_tips3: "을 봐 주세요. ",
                safari_setting_tips: "Safari를 사용하는 경우 다음 설정을 확인하십시오.\n설정 > Safari > 팝업 블록 > OFF 의 설\n정을 부탁드립니다. ",
                min_money_tips: "※ USD0.5~입력하실 수 있습니다.",
                law_tips: 'Specified Commercial Transaction Act',
                pay_urls: [{
                        name: "JP¥100",
                        url: "https://buy.stripe.com/4gw16J9ea1vN2IMdQS"
                    },
                    {
                        name: "JP¥500",
                        url: "https://buy.stripe.com/eVa02Fbmi5M31EI9AD"
                    }, {
                        name: "JP¥1,000",
                        url: "https://buy.stripe.com/00g02Fcqm1vNfvy7sw"
                    },
                    {
                        name: "JP¥10,000",
                        url: "https://buy.stripe.com/eVabLnfCy6Q7fvy7sx"
                    }
                ]

            },
            supportTitle: "SUPPORTERS",
            contactTitle: "CONTACT US",
            // OGP用情報
            ogp: {
                title: 'DANDELION PROJECT',
                description: '平和への祈りを、アートで繋ぐ。',
                type: 'website',
                url: 'www.breathbless.com',
                site_name: 'DANDELION PROJECT Official Site',
                image: '/Images/Ogp/OGP_breath.jpg',
                twitter_card: 'summary_large_image'
            },

            // タイトル
            title: 'Uniting Prayers for Peace',
            title_sp: 'Uniting' +
                '\r\n' +
                'Prayers' +
                '\r\n' +
                'for' +
                '\r\n' +
                'Peace',

            // サブタイトル
            subtitle: '平和への祈りを、アートで繋ぐ。',

            // ページの詳細
            description: 'これは、世界のあらゆる地点を結びながら、人々が参加することで成長するアート作品。\r\n' +
                '\r\n' +
                'たんぽぽの綿毛を飛ばすように、「Dandelion」に息を吹きかけると、\r\n' +
                'その綿毛は遠く離れた街へと舞い移り美しい花を咲かせます。\r\n' +
                '\r\n' +
                'さまざまな街から発せられる「Breath（吐息）」が、平和を願う「Bless（祈り）」の種となって世界へ。\r\n' +
                '\r\n' +
                'リアルとバーチャルがシンクロし、\r\n' +
                'ネットワークそのものが国境を越えるアートとして成長し続けます。',
            description_sp: 'これは、世界のあらゆる地点を結びながら、\r\n' +
                '人々が参加することで成長するアート作品。\r\n' +
                '\r\n' +
                'たんぽぽの綿毛を飛ばすように、「Dandelion」に息を吹きかけると、\r\n' +
                'その綿毛は遠く離れた街へと舞い移り美しい花を咲かせます。\r\n' +
                '\r\n' +
                'さまざまな街から発せられる「Breath（吐息）」が、\r\n' +
                '平和を願う「Bless（祈り）」の種となって世界へ。\r\n' +
                '\r\n' +
                'リアルとバーチャルがシンクロし、\r\n' +
                'ネットワークそのものが国境を越えるアートとして\r\n' +
                '成長し続けます。',

            // Send a Prayerボタンの接続先
            send_url: 'https://naked.co.jp/works/',

            title2: 'SEND A PRAYER',
            title2sp: 'SEND' +
                '\r\n' +
                'A' +
                '\r\n' +
                'PRAYER',
            subtitle2: 'あなたの平和への祈りで世界に花を咲かせましょう。',

            textcontents_qr: '今、『Dandelion』の近くにいる方',
            textcontents_qr_button: 'インタラクティブマーカー',

            textcontents_ol: 'オンラインから作品に参加される方',
            textcontents_ol_button: 'あなたの花を見つける',

            // Send a Prayerボタンから出るモーダルに表示される画像
            // send_modal_image: './Images/LP_dande_contents_0822.jpg',
            // send_modal_image_sp: './Images/LP_dande_SP-contents_0824.jpg',
            // send_modal_image_tb: './Images/LP_dande_ipad_0825.jpg',

            send_modal_image: './Images/maker_jp.jpg',
            // send_modal_image_sp: './Images/maker.jpg',
            // send_modal_image_tb: './Images/maker.jpg',

            // 会社ロゴ
            corporate_logo: './Images/NAKED,INC._Logotype_b.png',

            // 会社ロゴからの接続先
            corporate_url: 'https://naked.co.jp',

            // お問い合わせの接続先
            contact_url: 'https://naked.co.jp/contact/',

            // メッセージ
            //
            // thumbnail => サムネイル画像
            // title => タイトル
            // description => 詳細説明
            message: {
                thumbnail: './Images/RM.jpg',
                title: 'ARTIST',
                name: 'Ryotaro Muramatsu / NAKED ',
                description: 'アーティスト。NAKED, INC.代表。大阪芸術大学客員教授。長野県・阿智村ブランディングディレクター。 1997年にクリエイティブカンパニーNAKED, INC.を設立以来、映画やテレビ、MV、広告、空間演出など、ジャンルを超えてさまざまなプロジェクトを率いてきた。監督作品は長編/短編合わせて国際映画祭で48ノミネート&受賞。近年では「FLOWERS BY NAKED」「TOKYO ART CITY BY NAKED」などのイマーシブ(没入型)イベントや、華道・茶道・香道・歌舞伎・能狂言といった伝統文化・芸能と先進の表現を掛け合わせたインスタレーションや公演を手がける。大阪芸術大学で客員教授を務めるほか、ブランディング・ディレクターを務める長野県・阿智村をはじめ大阪府・堺市や佐賀県など日本各地での地方創生イベントや文化プロジェクトに取り組む。2018年には個人アーティストとしての創作活動を開始し、国内外で作品を発表してきた。',
                message: '2020年、この世界はさまざまな意味で大きく変わりました。' +
                    '\r\n' +
                    '不安の多い時期は続きそうですが、この経験が世界を分断するのではなく、むしろ新しいかたちで僕たちを結びつけるきっかけになって欲しいと感じています。' +
                    '\r\n' +
                    '\r\n' +
                    '人それぞれ異なるバックグラウンドを持っていますが、より良い世界になってほしいという思いは皆同じなのではないでしょうか。主義主張によって"一つの正しさ"を追求しようとすると終わりがありませんが、平和や平穏への祈りといった優しい感情を通して繋がり合う方法もあると信じたいです。' +
                    '\r\n' +
                    '\r\n' +
                    '「Dandelion」は、タンポポに息を吹きかけると舞い上がった綿毛が地面に根付き、新しい花を咲かせるインタラクティブ作品です。デジタルによって表現が拡張されるアートなのですが、タンポポに祈りを込めて吹くという、誰もが子供の頃に遊んだピュアな原体験的感覚を呼び起こすこの作品を、僕自身とても気に入っています。' +
                    '\r\n' +
                    '\r\n' +
                    '花は言葉を必要とせず、物事を分け隔てることもしません。' +
                    '\r\n' +
                    '種子を飛ばし、たどり着いた先でまた花を咲かせます。' +
                    '\r\n' +
                    'そんな風に、国や人種、思想に関わらず誰もが知っているシンプルな行為がアートとなって人々の祈りを繋げ、世界中に花を咲かせることができればと願っています。' +
                    '\r\n' +
                    '\r\n' +
                    '村松 亮太郎',
                message_sp: '『2020年、この世界はさまざまな意味で大きく変わりました。不安の多い時期は続きそうですが、この経験が世界を分断するのではなく、むしろ新しいかたちで僕たちを結びつけるきっかけになって欲しいと感じています。' +
                    '\r\n' +
                    '\r\n' +
                    '人それぞれ異なるバックグラウンドを持っていますが、より良い世界になってほしいという思いは皆同じなのではないでしょうか。主義主張によって"一つの正しさ"を追求しようとすると終わりがありませんが、平和や平穏への祈りといった優しい感情を通して繋がり合う方法もあると信じたいです。' +
                    '\r\n' +
                    '\r\n' +
                    '「Dandelion」は、タンポポに息を吹きかけると舞い上がった綿毛が地面に根付き、新しい花を咲かせるインタラクティブ作品です。デジタルによって表現が拡張されるアートなのですが、タンポポに祈りを込めて吹くという、誰もが子供の頃に遊んだピュアな原体験的感覚を呼び起こすこの作品を、僕自身とても気に入っています。' +
                    '\r\n' +
                    '\r\n' +
                    '花は言葉を必要とせず、物事を分け隔てることもしません。種子を飛ばし、たどり着いた先でまた花を咲かせます。' +
                    '\r\n' +
                    'そんな風に、国や人種、思想に関わらず誰もが知っているシンプルな行為がアートとなって人々の祈りを繋げ、世界中に花を咲かせることができればと願っています。』'
            },

            // サポーターのリンク
            //
            // logo => ロゴURL
            // url => リンク先URL
            supporters: [{
                    logo: './Images/Supporters/GB Logo SG_4C_Grey.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/sas.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/pds.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/tt.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/kddi.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_venice.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_tokyo.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_capetown.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/gl.png',
                    url: ''
                }
            ],

            // フレンドのリンク
            //
            // logo => ロゴURL
            // url => リンク先URL
            friends: [{
                    logo: './Images/Friends/friends_sanomisaki.png'
                },
                {
                    logo: './Images/Friends/friends_sanomasaki.png'
                },
                {
                    logo: './Images/Friends/friends_nobu.png'
                },
                {
                    logo: './Images/Friends/friends_jun.png'
                },
                {
                    logo: './Images/Friends/friends_ryuta.png'
                },
                {
                    logo: './Images/Friends/friends_shinsaku.png'
                },
                {
                    logo: './Images/Friends/friends_reiji.png'
                },
                {
                    logo: './Images/Friends/friends_erina.png'
                },
                {
                    logo: './Images/Friends/friends_etotokiko.png'
                },
                {
                    logo: './Images/Friends/friends_fukada.png'
                },
                {
                    logo: './Images/Friends/friends_kobayashi.png'
                },
                {
                    logo: './Images/Friends/friends_kuniya.png'
                },
                {
                    logo: './Images/Friends/friends_matsuda.png'
                },
                {
                    logo: './Images/Friends/friends_etomasakazu.png'
                },
                {
                    logo: './Images/Friends/friends_etomiho.png'
                },
            ],

            // 寄付のお願い
            contribution: {
                title_pc: '『Dandelion』植樹支援（作品設置支援）のお願い',
                title_sp: '『Dandelion』植樹支援（作品設置支援）のお願い',
                message: '「DANDELION PROJECT」は、平和への祈りのシンボルとなる『Dandelion』を' +
                    '\r\n' +
                    '世界各地に”植える(展示する)”ための支援金を募集しています。' +
                    '\r\n' +
                    '人々の想いを繋ぎ、世界中に花を咲かせる活動にぜひご参加ください。' +
                    '\r\n' +
                    '\r\n',
                message_sp: '「DANDELION PROJECT」は、' +
                    '\r\n' +
                    '平和への祈りのシンボルとなる『Dandelion』を' +
                    '\r\n' +
                    '世界各地に”植える(展示する)”ための' +
                    '\r\n' +
                    '支援金を募集しています。' +
                    '\r\n' +
                    '人々の想いを繋ぎ、世界中に花を咲かせる活動に' +
                    '\r\n' +
                    'ぜひご参加ください。' +
                    '\r\n' +
                    '\r\n',
                button: '植樹チケット',
                cloudfunding_abount: '',
                cloudfunding_description: '植樹チケット以外にも、様々な形でのご支援をお待ちしております。' +
                    '\r\n' +
                    '詳細は以下までお問い合わせください。',
                cloudfunding_description_sp: '植樹チケット以外にも、' +
                    '\r\n' +
                    '様々な形でのご支援をお待ちしております。' +
                    '\r\n' +
                    '詳細は以下までお問い合わせください。',
                cloudfunding_button: '支援に関するお問い合わせ',
                cloudfunding_image: './Images/cf_logo_padded.png',
                cloudfunding_url: 'https://camp-fire.jp/projects/view/314807'
            },

            // 各種SNSのリンク
            //
            // icon => アイコン
            // url => リンク先URL
            links: [{
                    icon: './Images/icon_facebook.png',
                    url: 'https://www.facebook.com/NAKEDINC.official/'
                },
                {
                    icon: './Images/icon_instagram.png',
                    url: 'https://www.instagram.com/naked_inc/'
                }
            ],
            place: [{
                    name_mb1: '일본 히로시마',
                    name_mb2: '오리즈루 타워',
                    image_mb: './Images/Place/mb/s00145.png',
                    name: '일본 히로시마 / 오리즈루 타워',
                    time: '2023.5.19 ー',
                    image: './Images/Place/s00145.png',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '대만·타이베이',
                    name_mb2: '송연 문화창조지구',
                    image_mb: './Images/Place/mb/s00176.png',
                    name: '대만·타이베이 / 송연 문화창조지구',
                    time: '2026.1.31 ー 2026.6.30',
                    image: './Images/Place/s00176.png',
                    tips: '일반공개',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '일본·도쿄',
                    name_mb2: '테라다 창고',
                    image_mb: './Images/Place/mb/s00175.png',
                    name: '일본·도쿄 / 테라다 창고',
                    time: '2026.1.10 ー 2026.3.15',
                    image: './Images/Place/s00175.png',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://meets.naked.works/gaudi/'
                }, {
                    name_mb1: '일본・효고',
                    name_mb2: '히메지성 산노마루 광장',
                    image_mb: './Images/Place/mb/s00174.png',
                    name: '일본・효고 / 히메지성 산노마루 광장',
                    time: '2025.11.22 ー 2025.12.11',
                    image: './Images/Place/s00174.png',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'http://himeji-castle-dandelion.art/'
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: '야사카 신사',
                    image_mb: './Images/Place/mb/s00173.png',
                    name: '일본・교토 / 야사카 신사',
                    time: '2025.8.8 ー 2025.8.17',
                    image: './Images/Place/s00173.png',
                    tips: '일반공개',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: '후시미 이나리 신사',
                    image_mb: './Images/Place/mb/s00172.png',
                    name: '일본・교토 / 후시미 이나리 신사',
                    time: '2025.7.19 ー 2025.8.17',
                    image: './Images/Place/s00172.png',
                    tips: '일반공개',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '일본・효고현',
                    name_mb2: '롯코 고산 식물원',
                    image_mb: './Images/Place/mb/s00171.png',
                    name: '일본・효고현 / 롯코 고산 식물원',
                    time: '2025.9.20 ー 2025.12.30',
                    image: './Images/Place/s00171.png',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://rokkomeetsart.jp/'
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: '옛 별궁 니조성',
                    image_mb: './Images/Place/mb/s00170.png',
                    name: '일본 교토 / 옛 별궁 니조성',
                    time: '2025.3.14 ー 2025.4.13',
                    image: './Images/Place/s00170.png',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://event.naked.works/nijojo/spring/ja/'
                }, {
                    name_mb1: '중국・베이징',
                    name_mb2: '박물관을 만나다',
                    image_mb: './Images/Place/mb/s00168.png',
                    name: '중국・베이징 / 박물관을 만나다',
                    time: '2024.11.15 ー 2025.2.16',
                    image: './Images/Place/s00168.png',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '일본・시가',
                    name_mb2: '히요시타이샤 신사（하쿠산히메 신사）',
                    image_mb: './Images/Place/mb/s00167.png',
                    name: '일본・시가 / 히요시타이샤 신사（하쿠산히메 신사）',
                    time: '2024.11.1 ー 2024.12.8',
                    image: './Images/Place/s00167.png',
                    tips: '일반공개',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '일본・이시카와',
                    name_mb2: '나야지',
                    image_mb: './Images/Place/mb/s00166.png',
                    name: '일본・이시카와 / 나야지',
                    time: '2024.10.25 ー 2024.11.24',
                    image: './Images/Place/s00166.png',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://yoru-sanpo.naked.works/natadera/'
                }, {
                    name_mb1: '일본・시가',
                    name_mb2: '히에이산 엔랴쿠지 사찰 샤카도 홀',
                    image_mb: './Images/Place/mb/s00164.png',
                    name: '일본・시가 / 히에이산 엔랴쿠지 사찰 샤카도 홀',
                    time: '2024.9.13 ー 2024.12.8',
                    image: './Images/Place/s00164.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '일본 시가',
                    name_mb2: '히코네 성',
                    image_mb: './Images/Place/mb/s00162.png',
                    name: '일본 시가 / 히코네 성',
                    time: '2024.3.22 ー 2024.4.9',
                    image: './Images/Place/s00162.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://www.knt.co.jp/ec/2023/hikone_night_tour/'
                },
                //  {
                //     name_mb1: '일본 오사카',
                //     name_mb2: '아베노하루카스 전망대 \'하루카스 300\'',
                //     image_mb: './Images/Place/mb/s00157.png',
                //     name: '일본 오사카 / 아베노하루카스 전망대 \'하루카스 300\'',
                //     time: '2023.11.28 ー 2024.3.31',
                //     image: './Images/Place/s00157.jpg',
                //     tips: '일반공개 / 입장료가 부과됩니다',
                //     url_msg: '상세내용',
                //     url: 'https://ultraxperience.jp/0x0mugen-project/page_clf.html'
                // }, 
                {
                    name_mb1: '일본 오사카',
                    name_mb2: '만국박람회 기념공원',
                    image_mb: './Images/Place/mb/s00156.png',
                    name: '일본 오사카 / 만국박람회 기념공원',
                    time: '2023.12.1 ー 2023.12.25',
                    image: './Images/Place/s00156.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '일본 시가',
                    name_mb2: '히코네 성',
                    image_mb: './Images/Place/mb/s00155.png',
                    name: '일본 시가 / 히코네 성',
                    time: '2023.11.11 ー 2023.12.9',
                    image: './Images/Place/s00155.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://www.knt.co.jp/ec/2023/hikone_night_tour/'
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: '옛 별궁 니조성',
                    image_mb: './Images/Place/mb/s00144.png',
                    name: '일본 교토 / 옛 별궁 니조성',
                    time: '2023.3.16 ー 2023.4.16',
                    image: './Images/Place/s00144.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 오사카',
                    name_mb2: 'W 오사카',
                    image_mb: './Images/Place/mb/s00141.png',
                    name: '일본 오사카 / W 오사카',
                    time: '2022.12.15 ー 2022.12.25',
                    image: './Images/Place/s00141.jpg',
                    tips: '일반공개',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: '교토국립박물관',
                    image_mb: './Images/Place/mb/s00136.png',
                    name: '일본 교토 / 교토국립박물관',
                    time: '2022.12.10 ー 2022.12.25',
                    image: './Images/Place/s00136.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: '닌나지(인화사)',
                    image_mb: './Images/Place/mb/s00135.png',
                    name: '일본 교토 / 닌나지(인화사)',
                    time: '2022.12.10 ー 2022.12.18',
                    image: './Images/Place/s00135.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: 'ACE HOTEL KYOTO',
                    image_mb: './Images/Place/mb/s00134.png',
                    name: '일본 교토 / ACE HOTEL KYOTO',
                    time: '2022.12.8 ー 2022.12.25',
                    image: './Images/Place/s00134.jpg',
                    tips: '일반공개',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 시가',
                    name_mb2: '니시혼간지・당문',
                    image_mb: './Images/Place/mb/s00133.png',
                    name: '일본 시가 / 니시혼간지・당문',
                    time: '2022.11.24 ー 2022.11.27',
                    image: './Images/Place/s00133.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: '헤이안진구(헤이안 신궁)',
                    image_mb: './Images/Place/mb/s00132.png',
                    name: '일본 교토 / 헤이안진구(헤이안 신궁)',
                    time: '2022.11.18 ー 2022.12.25',
                    image: './Images/Place/s00132.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: '키타노텐만구(키타노덴만 신사)',
                    image_mb: './Images/Place/mb/s00131.png',
                    name: '일본 교토 / 키타노텐만구(키타노덴만 신사)',
                    time: '2022.11.12 ー 2022.11.27',
                    image: './Images/Place/s00131.jpg',
                    tips: '기타노텐만구 라이트 업과 동시개최',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 우지',
                    name_mb2: '우지시',
                    image_mb: './Images/Place/mb/s00130.png',
                    name: '일본 우지 / 우지시',
                    time: '2022.11.11 ー 2022.12.4',
                    image: './Images/Place/s00130.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 시가',
                    name_mb2: '히코네 성',
                    image_mb: './Images/Place/mb/2022_10_dandelion_castle_fin_web.png',
                    name: '일본 시가 / 히코네 성',
                    time: '2022.11.3 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_castle_fin_web.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '일본 시가',
                    name_mb2: '히에이잔로쿠・시가인몬세키',
                    image_mb: './Images/Place/mb/2022_10_dandelion_monseki_fin_web.png',
                    name: '일본 시가 / 히에이잔로쿠・시가인몬세키',
                    time: '2022.11.3 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_monseki_fin_web.jpg',
                    tips: '일반공개（금요일 토요일 일요일 빨간날) / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '사우디 아라비아 리야드',
                    name_mb2: '알무라바',
                    image_mb: './Images/Place/mb/2022_10_dandelion_almurabaa_fin_web.png',
                    name: '사우디 아라비아 리야드 / 알무라바',
                    time: '2022.11.1 ー 2022.12.18',
                    image: './Images/Place/2022_10_dandelion_almurabaa_fin_web.jpg',
                    tips: '일반공개',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: '옛 별궁 니조성',
                    image_mb: './Images/Place/mb/2022_10_dandelion_nijojo_fin_web.png',
                    name: '일본 교토 / 옛 별궁 니조성',
                    time: '2022.10.28 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_nijojo_fin_web.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: '카미가모신사',
                    image_mb: './Images/Place/mb/2022_09_dandelion_kamigamoshrine_fin_web.png',
                    name: '일본 교토 / 카미가모신사',
                    time: '2022.10.21 ー 2022.10.23',
                    image: './Images/Place/2022_09_dandelion_kamigamoshrine_fin_web.jpg',
                    tips: '일반공개',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 오사카',
                    name_mb2: '우메키타 외부 정원 SQUARE',
                    image_mb: './Images/Place/mb/2022_09_dandelion_square_fin_web.png',
                    name: '일본 오사카 / 우메키타 외부 정원 SQUARE',
                    time: '2022.10.7 ー 2022.10.9',
                    image: './Images/Place/2022_09_dandelion_square_fin_web.jpg',
                    tips: '일반공개',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '​일본 교토',
                    name_mb2: '미츠이 가의 시모가모 저택',
                    image_mb: './Images/Place/mb/2022_09_dandelion_oldmitsuifamily_fin_web.png',
                    name: '​일본 교토 / 미츠이 가의 시모가모 저택',
                    time: '2022.9.23 ー 2022.10.2',
                    image: './Images/Place/2022_09_dandelion_oldmitsuifamily_fin_web.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: '교토시청',
                    image_mb: './Images/Place/mb/2022_09_dandelion_shiyakusyo_fin_web.png',
                    name: '일본 교토 / 교토시청',
                    time: '2022.9.15 ー 2022.9.16',
                    image: './Images/Place/2022_09_dandelion_shiyakusyo_fin_web.jpg',
                    tips: '일반공개',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '일본 시가',
                    name_mb2: '연랴쿠지',
                    image_mb: './Images/Place/mb/2022_07_dandelion_hieizan_pers_fin_web.png',
                    name: '일본 시가 / 연랴쿠지',
                    time: '2022.8.4 ー 2022.8.31',
                    image: './Images/Place/2022_07_dandelion_hieizan_pers_fin_web.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '일본 교토',
                    name_mb2: '헤이안진구(헤이안 신궁)',
                    image_mb: './Images/Place/mb/2021_09_dande_heianjingu_fin_web.png',
                    name: '일본 교토 / 헤이안진구(헤이안 신궁)',
                    time: '2021.12.15 ー 2022.1.16',
                    image: './Images/Place/2021_09_dande_heianjingu_fin_web.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '일본 교토',
                    name_mb2: '아라시야마',
                    image_mb: './Images/Place/mb/2021_09_dande_arashiyama_fin_web.png',
                    name: '일본 교토 / 아라시야마',
                    time: '2021.12.10 ー 202.12.19',
                    image: './Images/Place/2021_09_dande_arashiyama_fin_web.jpg',
                    tips: '일반공개',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '일본 교토',
                    name_mb2: '코쇼지(흥성사)',
                    image_mb: './Images/Place/mb/2021_10_dande_koushouji_fin_web.png',
                    name: '일본 교토 / 코쇼지(흥성사)',
                    time: '2021.12.3 ー 2021.12.5',
                    image: './Images/Place/2021_10_dande_koushouji_fin_web.jpg',
                    tips: '일반공개 / 야간 관람료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '일본 시가 ',
                    name_mb2: '히코네 성',
                    image_mb: './Images/Place/mb/2021_11_dande_hikono_fin_web.png',
                    name: '일본 시가 / 히코네 성',
                    time: '2021.11.27 ー 2022.1.30',
                    image: './Images/Place/2021_11_dande_hikono_fin_web.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '元離宮二条城',
                    image_mb: './Images/Place/mb/2021_10_dande_kochijo_a4_fin_web.png',
                    name: '일본 고치 / 고치 성',
                    time: '2021.11.19 ー 2022.01.10',
                    image: './Images/Place/2021_10_dande_kochijo_a4_fin_web.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://flowers.naked.works/kochi-castle/'
                },
                {
                    name_mb1: '일본 구마모토',
                    name_mb2: '구마모토 성',
                    image_mb: './Images/Place/mb/2021_dande_kumamotojo_0928_fin_web.png',
                    name: '일본 구마모토 / 구마모토 성',
                    time: '2021.11.19 ー 2021.12.05',
                    image: './Images/Place/2021_dande_kumamotojo_0928_fin_web.jpg',
                    tips: '일반공개',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '일본 교토',
                    name_mb2: '키요미즈데라(청수사)',
                    image_mb: './Images/Place/mb/2021_10_dande_kiyomizu_1011_fin_web.png',
                    name: '일본 교토 / 키요미즈데라(청수사)',
                    time: '2021.11.17',
                    image: './Images/Place/2021_10_dande_kiyomizu_1011_fin_web.jpg',
                    tips: '일반공개 없음',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '일본 교토',
                    name_mb2: '키타노텐만구(키타노덴만 신사)',
                    image_mb: './Images/Place/mb/2021_10_dande_kitanotenmangu3_1020_fin_web.png',
                    name: '일본 교토 / 키타노텐만구(키타노덴만 신사)',
                    time: '2021.11.13 ー 2021.11.14',
                    image: './Images/Place/2021_10_dande_kitanotenmangu3_1020_fin_web.jpg',
                    tips: '기타노텐만구 라이트 업과 동시개최',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '프랑스 파리',
                    name_mb2: '사마리텐',
                    image_mb: './Images/Place/mb/2021_10_dande_pari_1025-3_web.png',
                    name: '프랑스 파리 / 사마리텐',
                    time: '2021.11.8 ー 2021.11.20',
                    image: './Images/Place/2021_10_dande_pari_1025-3_web.jpg',
                    tips: '일반공개',
                    url_msg: '',
                    url: ''
                },


                {
                    name_mb1: '일본 교토',
                    name_mb2: '닌나지(인화사)',
                    image_mb: './Images/Place/mb/2021_10_dande_ninnaji_1011_fin_web.png',
                    name: '일본 교토 / 닌나지(인화사)',
                    time: '2021.11.2',
                    image: './Images/Place/2021_10_dande_ninnaji_1011_fin_web.jpg',
                    tips: '일반공개 없음',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '일본 교토',
                    name_mb2: '카미가모진자(카미가모 신사)',
                    image_mb: './Images/Place/mb/2021_09_dande_kamigamo_fin_web.png',
                    name: '일본 교토 / 카미가모진자(카미가모 신사)',
                    time: '2021.10.27',
                    image: './Images/Place/2021_09_dande_kamigamo_fin_web.jpg',
                    tips: '일반공개 없음',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '일본 도쿄',
                    name_mb2: 'TBS',
                    image_mb: './Images/Place/mb/2021_10_dande_TVasa_0907-2_fin_web.png',
                    name: '일본 도쿄 / TBS',
                    time: '2021.10.1 ー 2021.10.31',
                    image: './Images/Place/2021_10_dande_TVasa_0907-2_fin_web.jpg',
                    tips: '일반공개',
                    url_msg: '',
                    url: ''


                },
                {
                    name_mb1: '일본 사가',
                    name_mb2: '사가현청 전망홀',
                    image_mb: './Images/Place/mb/2021_10_damde_saga_fin_web.png',
                    name: '일본 사가 / 사가현청 전망홀',
                    time: '2021.9.28 ー',
                    image: './Images/Place/2021_10_damde_saga_fin_web.jpg',
                    tips: '일반공개 / 입장료가 부과됩니다',
                    url_msg: '상세내용',
                    url: 'https://garden.naked.works/saga/'


                },
                {
                    name_mb1: '일본 사이타마',
                    name_mb2: '무민 밸리 파크',
                    image_mb: './Images/Place/mb/2020_11_dande_moomin_fin_web.png',
                    name: "일본 사이타마 / 무민 밸리 파크",
                    time: "2020.11.21 ー 2021.03.07",
                    image: "./Images/Place/2020_11_dande_moomin_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '일본 도쿄',
                    name_mb2: '시부야 구립 미야시타 공원',
                    image_mb: './Images/Place/mb/2020_09_dande_miyashita_fin_web.png',
                    name: "일본 도쿄 / 시부야 구립 미야시타 공원",
                    time: "2020.11.09 ー 2020.11.15",
                    image: "./Images/Place/2020_09_dande_miyashita_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '싱가포르',
                    name_mb2: 'Gardens by the Bay',
                    image_mb: './Images/Place/mb/2020_09_dande_singapore_fin_web.png',
                    name: "싱가포르 / Gardens by the Bay",
                    time: "2020.11.09 ー 2020.11.15",
                    image: "./Images/Place/2020_09_dande_singapore_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '일본 도쿄',
                    name_mb2: '도쿄타워',
                    image_mb: './Images/Place/mb/2021_09_dande_tokyotower_a4_fin_web.png',
                    name: "일본 도쿄 / 도쿄타워",
                    time: "2020.11.09 ー",
                    image: "./Images/Place/2021_09_dande_tokyotower_a4_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                }
            ]
        }
    }
}